import { Dialog, Checkbox } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';

const svc = new ResourceSvc();

const MODE_CLUB_ONLY = 'ClubOnly';

export default {
    name: 'RenewalOptInModal',
    components: {
        [Dialog.name]: Dialog,
        [Checkbox.name]: Checkbox
    },
    props: {
        visible: { type: Boolean, default: false },
        eligibility: { type: Object, default: null }
    },
    data() {
        return {
            tiSelected: false,
            selectedClubIds: [],
            isSaving: false
        };
    },
    computed: {
        localVisible: {
            get() { return this.visible; },
            set(value) { this.$emit('update:visible', value); }
        },
        mode() {
            return this.eligibility ? this.eligibility.mode : null;
        },
        clubs() {
            return this.eligibility && this.eligibility.clubs ? this.eligibility.clubs : [];
        },
        renewalYear() {
            return this.eligibility ? this.eligibility.renewalYear : null;
        },
        tiMembershipName() {
            const name = this.eligibility ? this.eligibility.tiMembershipName : null;

            // The enum label is "Swim Plus Membership"; the renewal surfaces show it as "Swim+".
            return name ? name.replace('Swim Plus', 'Swim+') : name;
        },
        isTiReadOnly() {
            return this.mode === MODE_CLUB_ONLY;
        },
        hasNewSelection() {
            if (this.selectedClubIds.length > 0) {
                return true;
            }

            return !this.isTiReadOnly && this.tiSelected;
        }
    },
    watch: {
        eligibility: {
            immediate: true,
            handler() {
                this.reset();
            }
        },
        tiSelected(value) {
            if (!value) {
                this.selectedClubIds = [];
            }
        }
    },
    methods: {
        reset() {
            this.tiSelected = this.isTiReadOnly;
            this.selectedClubIds = [];
            this.isSaving = false;
        },
        isClubSelected(clubId) {
            return this.selectedClubIds.indexOf(clubId) !== -1;
        },
        toggleClub(clubId, isChecked) {
            if (isChecked) {
                if (!this.isClubSelected(clubId)) {
                    this.selectedClubIds.push(clubId);
                }
                return;
            }

            this.selectedClubIds = this.selectedClubIds.filter(id => id !== clubId);
        },
        close() {
            if (this.isSaving) {
                return;
            }

            this.localVisible = false;
        },
        async submit() {
            if (this.isSaving || !this.hasNewSelection) {
                return;
            }

            this.isSaving = true;

            try {
                const response = await svc.submitCampaignRenewalOptIn({
                    optInTi: this.tiSelected,
                    clubIds: this.selectedClubIds
                });

                const result = response && response.body;

                if (result && result.isSuccess) {
                    this.$showSuccess(`Your ${this.renewalYear} auto-renewal preferences have been saved.`);
                    this.localVisible = false;
                    this.$emit('saved');
                    return;
                }

                this.$showError(result && result.message);
            } catch (e) {
                this.$showError();
            } finally {
                this.isSaving = false;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/membership-renewal-opt-in/renewal-opt-in-modal.js